import useFetcher from 'hooks/useFetcher/useFetcher';
import { ServiceTypes } from 'hooks/useFetcher/interfaces';
import { stringifyUrl, getRequest } from 'utils';
import { Properties } from 'types';

// The `type` value the backend assigns to contact/lead exports.
export const LEAD_EXPORT_TYPE = 'leads';

export const useExportsAPI = (): Properties => {
  const fetcher = useFetcher(ServiceTypes.CRM);

  return {
    getExports: ({ queryKey: [, query] }) => {
      return fetcher(stringifyUrl('/exports', query), getRequest);
    },
    downloadExport: (id: number) => {
      return fetcher(`/exports/${id}/download`, { blob: true });
    },
  };
};
